<template>
  <div class="admin-business-container">
    <div v-if="!loading">
      <div v-if="showBusinessesList">
        <TopButtonsComponent
          :jobCreatorId="jobCreatorId"
          v-on:backToJobs="$emit('backToJobs', 'Jobs')"
          v-on:backToPostJob="$emit('backToPostJob', 'Post Job')"
        />

        <div class="admin-business-list-holder">
          <ListTable
            :headList="headList"
            :bodyList="currentJobsList"
            v-if="allBusinesses"
            v-on:viewHandler="viewBusiness"
            v-on:enableHandler="enableBusiness"
            v-on:disableHandler="disableBusiness"
            v-on:deleteHandler="deleteBusiness"
          />
          <EmptyDashboardState
            v-if="!allBusinesses"
            v-bind:emptyHeading="emptyStateTitle"
            v-bind:desc="jobDesc"
          />
        </div>

        <div class="pagination">
          <Pagination
            v-if="bodyList !== null"
            v-bind:itemsPerPage="itemsPerPage"
            v-bind:totalJobs="bodyList.length"
            v-bind:currentPage="currentPage"
            v-on:paginate="paginate"
          />
        </div>
      </div>
      <div v-else>
        <UserDetailsPage
          v-on:back="setView"
          :userDetailsData="userDetailsData"
        />
      </div>
      <!-- Modal component for actions confirmation -->
      <div v-if="showModal">
        <ActionModal
          :verb="modalVerb"
          :subject="modalSubject"
          v-on:modalAction="modalAction"
        />
      </div>
    </div>

    <!-- Loader Component -->
    <Loader v-if="loading" />
  </div>
</template>
<script>
import TopButtonsComponent from '../../components/JobDetail/TopButtonsComponent.vue';
import ListTable from '../../components/body/ListTable.vue';
import EmptyDashboardState from '../../components/EmptyDashboardState.vue';
import Pagination from '../../components/Pagination.vue';
import ActionModal from '../../components/Modals/ActionModal.vue';
import Loader from '../../components/body/Loader.vue';

import threeDotsIcon from '../../assets/images/tableDots.png';
import UserDetailsPage from './UserDetailsPage.vue';

export default {
  name: 'AdminBusinessesList',
  props: ['jobCreatorId'],
  components: {
    TopButtonsComponent,
    ListTable,
    EmptyDashboardState,
    Pagination,
    ActionModal,
    Loader,
    UserDetailsPage
  },
  data() {
    return {
      loading: false,
      allBusinesses: null,
      showBusinessesList: true,
      userDetailsData: null,
      jobs: null,

      headList: [
        {
          text: 'COMPANY',
        },
        {
          text: 'EMAIL',
        },
        {
          text: 'PHONE NO',
        },
        {
          text: 'TOTAL JOBS',
        },
        {
          text: 'LOCATION',
        },
        {
          text: '',
        },
      ],
      bodyList: null,
      threeDotsIcon,

      emptyStateTitle: 'Businesses',
      jobDesc: 'Businesses Not Available',

      currentPage: 1,
      itemsPerPage: 10,

      showModal: false,
      modalSubjectId: null,
      modalVerb: null,
      modalSubject: null,
    };
  },
  async mounted() {
    await this.getAllBusinesses();
  },
  computed: {
    indexOfLastJob() {
      return this.currentPage * this.itemsPerPage;
    },

    indexOfFirstJob() {
      return this.indexOfLastJob - this.itemsPerPage;
    },

    currentJobsList() {
      return this.bodyList.slice(this.indexOfFirstJob, this.indexOfLastJob);
    },
  },
  methods: {
    setView(option){
      option === 'parent'?
        this.showBusinessesList = true : this.$emit('backToPostJob', 'Post Job');
    },
    viewBusiness(businessId) {
      this.userDetailsData = this.allBusinesses.find(business => {
        return business.id === businessId;
      });
      this.showBusinessesList = false;
    },
    enableBusiness(businessId) {
      this.showModal = !this.showModal;
      this.modalSubjectId = businessId;
      this.modalVerb = 'enable';
      this.modalSubject = 'business';
    },
    disableBusiness(businessId) {
      this.showModal = !this.showModal;
      this.modalSubjectId = businessId;
      this.modalVerb = 'disable';
      this.modalSubject = 'business';
    },
    deleteBusiness(businessId) {
      this.showModal = !this.showModal;
      this.modalSubjectId = businessId;
      this.modalVerb = 'delete';
      this.modalSubject = 'business';
    },
    async modalAction(value) {
      //toggle modal
      this.showModal = !this.showModal;
      // decide action

      switch (true) {
        case this.modalSubject === 'business' && this.modalVerb === 'enable':
          value === 'yes'
            ? this.sendDispatchCall('enableUser', this.modalSubjectId)
            : this.closeModal();
          break;

        case this.modalSubject === 'business' && this.modalVerb === 'disable':
          value === 'yes'
            ? this.sendDispatchCall('disableUser', this.modalSubjectId)
            : this.closeModal();
          break;

        case this.modalSubject === 'business' && this.modalVerb === 'delete':
          value === 'yes'
            ? this.sendDispatchCall('deleteUser', this.modalSubjectId)
            : this.closeModal();
          break;

        default:
          break;
      }
    },
    sendDispatchCall(dispatchAction, entityId) {
      this.loading = true;
      this.$store.dispatch(dispatchAction, entityId).then((res) => {
        if (res.response) {
          this.loading = false;
          this.$toastr.success(
            res.response ? res.response.message : res.response,
            'Success'
          );
          this.$router.go();
        } else if (res.error) {
          this.loading = false;
          this.$toastr.error(
            res.error.error
            ? res.error.error
            : res.error
            ? res.error.message
            : res.error,
            'Failed'
          );
        }
        this.closeModal();
      });
    },
    closeModal() {
      this.showModal = false;
      this.modalVerb = null;
      this.modalSubject = null;
      this.modalSubjectId = null;
    },
    paginate(pageNumber) {
      this.currentPage = pageNumber;
    },
    async getAllBusinesses() {
      this.loading = true;
      await this.$store.dispatch('getAllBusinesses').then(() => {
        this.allBusinesses = this.$store.state.allBusinesses;

        // Modify each business' data to suit table

        this.bodyList = [];
        this.allBusinesses.forEach((business) => {
          let body = {
            company: business.companyName ? business.companyName : `${business.firstName} ${business.lastName}`,
            email: business.emailAddress,
            phone: !business.phone ? '—' : business.phone,
            numberOfApplications: !business.posts.length
              ? '0'
              : business.posts.length,
            address: business.city && business.state ? `${business.city}, ${business.state}`
                      : business.city ? business.city
                      : business.state ? business.state
                      : '—',
            threeDotsIcon: threeDotsIcon,
            id: business.id,
            isEnabled: business.isEnabled,
            showDeleteButton: true
          };
          this.bodyList.push(body);
        });

        this.loading = false;
      });
    },
  },
};
</script>

<style scoped>
.admin-business-list-holder {
  background: var(--white);
  border: 0.5px solid rgba(201, 201, 201, 0.35);
  box-sizing: border-box;
  box-shadow: 0px 14px 24px rgba(9, 44, 76, 0.1);
  border-radius: 10px 10px;
}
.pagination {
  margin-top: 30px;
  display: flex;
  justify-content: right;
  align-items: center;
}
</style>
